import {
  ADD_FAVOURITE_TEAM,
  ADD_FAVOURITE_TEAM_SUCCESS,
  FETCH_TEAM,
  FETCH_TEAM_SUCCESS,
  FETCH_ALL_TEAM,
  FETCH_ALL_TEAM_SUCCESS,
  FILTER_TEAM,
  GET_ALL_TEAM,
  GET_UNSELECTED_ALL_TEAM,
  HANDLE_TEAM_REQUEST_CLOSE,
  HIDE_TEAM_LOADER,
  SHOW_TEAM_LOADER,
  ON_ADD_TEAM,
  ON_EDIT_TEAM,
  SET_TEAM,
  ON_ALL_TEAM_SELECT,
  ON_TEAM_CLOSE,
  ON_TEAM_SELECT,
  ON_DELETE_TEAM,
  ON_DELETE_TEAM_SUCCESS,
  ON_FILTER_SELECTED_TEAM,
  ON_FILTER_TEAM_OPTION_SELECT,
  ON_SAVE_TEAM,
  ON_SAVE_TEAM_SUCCESS,
  ON_TOGGLE_TEAM_DRAWER,
  SHOW_TEAM_MESSAGE,
  UPDATE_SEARCH_TEAM,
  ON_FETCH_SELECT_MEMBER_DATA,
  ON_FETCH_SELECT_MEMBER_DATA_SUCCESS,
  ON_TEAM_MEMBER_UPDATE,
} from 'constants/ActionTypes';

export const onTeamMemberUpdate = () => {
  return {
      type: ON_TEAM_MEMBER_UPDATE,
  };
};
export const onFetchSelectMemberData = () => {
  return {
      type: ON_FETCH_SELECT_MEMBER_DATA,
  };
};
export const onFetchSelectMemberDataSuccess = (payload) => {
  return {
      type: ON_FETCH_SELECT_MEMBER_DATA_SUCCESS,
      payload
  };
};
export const setTeam = (payload) => {
  return {
      type: SET_TEAM,
      payload
  };
};
export const fetchTeam = (payload) => {
  return {
      type: FETCH_TEAM,
      payload
  };
};
export const fetchTeamSuccess = (payload) => {
  return {
      type: FETCH_TEAM_SUCCESS,
      payload
  };
};
export const fetchTeams = () => {
  return {
      type: FETCH_ALL_TEAM
  };
};
export const fetchTeamsSuccess = (payload) => {
  return {
      type: FETCH_ALL_TEAM_SUCCESS,
      payload
  };
};
export const showTeamMessage = (message) => {
  return {
      type: SHOW_TEAM_MESSAGE,
      payload: message
  };
};
export const addFavouriteTeam = (payload) => {
  return {
      type: ADD_FAVOURITE_TEAM,
      payload
  };
};
export const addFavouriteTeamSuccess = (payload) => {
  return {
      type: ADD_FAVOURITE_TEAM_SUCCESS,
      payload
  };
};
export const onTeamSelect = (payload) => {
  return {
      type: ON_TEAM_SELECT,
      payload
  };
};
export const onAddTeam = () => {
  return {
      type: ON_ADD_TEAM,
  };
};
export const onEditTeam = (payload) => {
  return {
      type: ON_EDIT_TEAM,
      payload
  };
};
export const onTeamClose = () => {
  return {
      type: ON_TEAM_CLOSE,
  };
};
export const onFilterTeamOptionSelect = (payload) => {
  return {
      type: ON_FILTER_TEAM_OPTION_SELECT,
      payload
  };
};
export const onSaveTeam = (payload) => {
  return {
      type: ON_SAVE_TEAM,
      payload
  };
};
export const onSaveTeamSuccess = (data) => {
  return {
      type: ON_SAVE_TEAM_SUCCESS,
      payload: data
  };
};
export const onDeleteTeam = (payload) => {
  return {
      type: ON_DELETE_TEAM,
      payload
  };
};
export const onDeleteTeamSuccess = (payload) => {
  return {
      type: ON_DELETE_TEAM_SUCCESS,
      payload
  };
};
export const onFilterSelectedTeam = () => {
  return {
      type: ON_FILTER_SELECTED_TEAM,
      payload: ''
  };
};
export const filterTeam = (payload) => {
  return {
      type: FILTER_TEAM,
      payload
  };
};
export const getAllTeam = () => {
  return {
      type: GET_ALL_TEAM,
      payload: ''
  };
};
export const getUnselectedAllTeam = () => {
  return {
      type: GET_UNSELECTED_ALL_TEAM,
      payload: ''
  };
};
export const onAllTeamSelect = () => {
  return {
      type: ON_ALL_TEAM_SELECT,
      payload: ''
  };
};
export const updateSearchTeam = (payload) => {
  return {
      type: UPDATE_SEARCH_TEAM,
      payload
  };
};
export const onToggleTeamDrawer = () => {
  return {
      type: ON_TOGGLE_TEAM_DRAWER,
  };
};
export const handleTeamRequestClose = () => {
  return {
      type: HANDLE_TEAM_REQUEST_CLOSE,
  };
};
export const showTeamLoader = () => {
  return {
      type: SHOW_TEAM_LOADER,
  };
};
export const hideTeamLoader = () => {
  return {
      type: HIDE_TEAM_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/team.js